// jQuery and Round Slider are used by the colour wheel and nothing else on the site, so they
// are no longer loaded in the layout on every page. They are fetched from /assets/vendor only
// once a wheel is actually on the page, which keeps ~120kb of third-party script off every
// other page and off the render-blocking path entirely.
const VENDOR = {
    jquery: '/assets/vendor/jquery-3.2.1.min.js',
    roundSliderJs: '/assets/vendor/roundslider-1.6.1.min.js',
    roundSliderCss: '/assets/vendor/roundslider-1.6.1.min.css',
};

function loadScript(src) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.head.appendChild(script);
    });
}

function loadStylesheet(href) {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
}

export default function ColourWheel() {
    // Nothing to do - and nothing to download - unless this page has a wheel on it.
    if (document.getElementById('ColourWheelBaseColour') === null) {
        return;
    }

    loadStylesheet(VENDOR.roundSliderCss);

    // Round Slider is a jQuery plugin, so jQuery has to finish loading first.
    loadScript(VENDOR.jquery)
        .then(() => loadScript(VENDOR.roundSliderJs))
        .then(colourWheelInit)
        .catch((error) => console.error('Error loading colour wheel dependencies:', error));
}

function colourWheelInit() {
    const baseColour = document.getElementById('ColourWheelBaseColour');
    if (baseColour === null) {
        return;
    }
    const baseColourPointer = document.getElementById('ColourWheelBaseColourPointer');
    const colourWheelSwatchGradientInner = document.querySelector('.colour-wheel-swatch__gradient-inner');
    const colourWheelShadeSlider = document.getElementById('ColourWheelShadeSlider');
    let isDown = false;
    let isUp = false;
    const defaultColour = [200, 246, 150];
    let rgbCode = defaultColour.join(',');
    $(colourWheelShadeSlider).roundSlider({
        handleShape: 'dot',
        handleSize: '+12',
        startAngle: 90,
        min: -100,
        max: 100,
        value: -100,
        showTooltip: false,
        change: function (event, ui) {
            getShade(this.getValue());
            SetCta();
        },
        drag: function (event, ui) {
            getShade(this.getValue());
        }
    });

    const colourWheelWrapper = document.querySelector('.colour-wheel-wrapper');
    const testCanvas = document.getElementById('TestCanvas');
    const testCtx = testCanvas.getContext('2d', { willReadFrequently: true });
    const image = document.getElementById('ColourPng');

    image.decode().then(() => {
        console.log('Colour wheel loaded');
        testCtx.drawImage(image, 1, 1, 280, 280);
        colourWheelWrapper.classList.remove('is-loading');
    });

    const colourCanvas = document.getElementById('colourCanvas');
    const colourCanvasCtx = colourCanvas.getContext('2d');
    drawColourCanvas(defaultColour);
    colourWheelSwatchGradientInner.style.background = 'linear-gradient(45deg, rgb(0, 0, 0), rgb(' + defaultColour[0] + ',' + defaultColour[1] + ',' + defaultColour[2] + '), rgb(250, 250, 250))';
    $(colourWheelShadeSlider).find('.rs-block').css('background', 'linear-gradient(rgb(0, 0, 0), rgb(' + defaultColour[0] + ',' + defaultColour[1] + ',' + defaultColour[2] + '), rgb(240, 240, 240))');

    baseColour.addEventListener('mousedown', function () {
        isDown = true;
        isUp = false;
    });

    baseColour.addEventListener('mouseleave', function () {
        isDown = false;
    });

    baseColour.addEventListener('touchstart', function (e) {
        if (e.type === "touchstart") {
            getColour(e);
        }
    })

    baseColour.addEventListener('touchend', function(e) {
        if (e.type === "touchend") {
            SetCta();
        }
    })

    window.addEventListener('mouseup', function () {
        isDown = false;
        SetCta();
    });

    window.addEventListener('mousemove', function (ev) {
        if (isDown) {
            getColour(ev);
        }
    });

    function getColour(ev) {
        var rect = baseColour.getBoundingClientRect();
        var x; //x position within the element.
        var y;  //y position within the element.

        if (ev.type === "touchstart") {
            x = ev.touches[0].clientX - rect.left;
            y = ev.touches[0].clientY - rect.top;
        } else {
            x = ev.clientX - rect.left;
            y = ev.clientY - rect.top;
        }

        const centre = 140;
        const radius = 140;
        const dx = x - centre;
        const dy = y - centre;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist > radius) {
            const scale = radius / dist;
            x = centre + dx * scale;
            y = centre + dy * scale;
        }

        var p = testCtx.getImageData(x, y, 1, 1).data;

        colourWheelSwatchGradientInner.style.background = 'linear-gradient(45deg, rgb(0, 0, 0), ' + 'rgb(' + p[0] + ',' + p[1] + ',' + p[2] + '), rgb(250, 250, 250))';

        $(colourWheelShadeSlider).find('.rs-block').css('background', 'linear-gradient(rgb(0, 0, 0), rgb(' + p[0] + ',' + p[1] + ',' + p[2] + '), rgb(240, 240, 240)');

        baseColourPointer.style.left = x + 'px';
        baseColourPointer.style.top = y + 'px';
        baseColourPointer.style.background = 'rgb(' + p[0] + ',' + p[1] + ',' + p[2] + ')';

        drawColourCanvas(p);
        rgbCode = p[0] + ',' + p[1] + ',' + p[2];
      

        if (x > 280 || x <= 0) {
            isDown = false;
        } else if (y > 280 || y <= 0) {
            isDown = false;
        }
    }
    function SetCta() {
       
        let ctaContainer = document.querySelector('.colour-wheel-cta');
        let cta = ctaContainer.getElementsByClassName("button")[0];
        const culture = document.documentElement.lang;
        fetch(ctaContainer.dataset.colourresolve + "?rgbCode=" + rgbCode + "&culture=" + encodeURIComponent(culture),
            {
                method: 'GET',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
            })
            .then(
                response => 
                    response.text().then(function(text ) {
                        if (text) {
                            cta.setAttribute('href', text);
                            cta.classList.remove('is-disabled');
                            cta.removeAttribute('aria-disabled');
                        } else {
                            cta.removeAttribute('href');
                            cta.classList.add('is-disabled');
                            cta.setAttribute('aria-disabled', 'true');
                        }
                    })
            )

    }

    function drawColourCanvas(colourData) {
        const grad = colourCanvasCtx.createLinearGradient(0, 0, 0, 100);
        grad.addColorStop(0, 'rgb(0, 0, 0)');
        grad.addColorStop(0.5, 'rgb(' + colourData[0] + ',' + colourData[1] + ',' + colourData[2] + ')');
        grad.addColorStop(1, 'rgb(250, 250, 250)');
        colourCanvasCtx.fillStyle = grad;
        colourCanvasCtx.fillRect(0, 0, 100, 100);
    }

    // Function to get shade of selected colour.
    // May improve this in future to calculate hsl/hwb result
    function getShade(value) {
        let valueToUse;
        if (value <= -100) {
            valueToUse = 200 + value;
        } else if (value > -100 && value <= 0) {
            valueToUse = 100 + value;
        }

        if (value > 100 && value <= 200) {
            valueToUse = 200 - value;
        } else if (value > 0 && value <= 100) {
            valueToUse = 200 - value;
            valueToUse = valueToUse - 100;
        }

        if (value == 100 || value == -100) {
            valueToUse = 1;
        } else if (value == 0) {
            valueToUse = 99;
        }
       
        colourWheelSwatchGradientInner.style.transform = 'translateY(' + valueToUse + '%)';

        var p = colourCanvasCtx.getImageData(valueToUse, valueToUse, 1, 1).data;

        console.log('rgb colour to use:', 'rgb(' + p[0] + ',' + p[1] + ',' + p[2] + ')');
      
        rgbCode = p[0] + ',' + p[1] + ',' + p[2];
    }
}